export const VENUE_SELECTOR_CONST = {
  invalid_venue: "Sorry, we couldn't find that base. Please try again.",
  redirect_error: "Could not redirect. Please try again.",
  placeholder: "Example: Camp Rudder",
  signup_desktop: "Sign Up Now",
  signup_mobile: "Sign Up",
  cta: "Select your base to get started:",
  error_cta: "Please enter a base name."
}